(function () {
  var MOBILE_BREAKPOINT = 749;
  var FALLBACK_URL = '/collections/tagesangebote';

  function isMobile() {
    return window.matchMedia('(max-width: ' + MOBILE_BREAKPOINT + 'px)').matches;
  }

  function normalizeText(node) {
    return (node && node.textContent || '').trim().toLowerCase();
  }

  function findClickableCandidates() {
    var nodes = Array.prototype.slice.call(document.querySelectorAll(
      'summary, button, a'
    ));
    return nodes.filter(function (el) {
      return /tagesangebote/i.test(normalizeText(el));
    });
  }

  function findHrefNear(el) {
    var a = el.tagName === 'A' ? el : el.querySelector('a[href]');
    if (a && a.href) return a.href;
    var li = el.closest('li');
    if (li) {
      var a2 = li.querySelector('a[href]');
      if (a2 && a2.href) return a2.href;
    }
    var a3 = document.querySelector('a[href*="/collections/tagesangebote"]');
    if (a3 && a3.href) return a3.href;
    return FALLBACK_URL;
  }

  function enableDirectNavigation() {
    if (!isMobile()) return;
    var handled = false;
    var candidates = findClickableCandidates();
    if (!candidates.length) return;

    candidates.forEach(function (el) {
      if (el.dataset.tagesangeboteBound === '1') return;
      el.dataset.tagesangeboteBound = '1';

      el.addEventListener('click', function (e) {
        try {
          var href = findHrefNear(el);
          if (!href) return;
          e.preventDefault();
          e.stopPropagation();
          if (handled && location.href === href) return;
          handled = true;
          window.location.assign(href);
        } catch (err) {
          console && console.warn && console.warn('Tagesangebote redirect error:', err);
        }
      }, { capture: true });
    });
  }

  document.addEventListener('DOMContentLoaded', enableDirectNavigation);
  document.addEventListener('shopify:section:load', enableDirectNavigation);
  document.addEventListener('shopify:section:select', enableDirectNavigation);
  document.addEventListener('shopify:section:deselect', enableDirectNavigation);
  document.addEventListener('shopify:inspector:activate', enableDirectNavigation);
})();
